import React from 'react';

import useEventSettingsForm, { EventFormProps } from '../useEventSettingsForm';

import EventActiveControl from '../controls/EventActiveControl';
import EventLevelControl from '../controls/EventLevelControl';
import EventTimeIntervalControl from '../controls/EventTimeIntervalControl';
import EventFormControls from '../controls/EventFormControls';
import PlayEventSoundControl from '../controls/PlayEventSoundControl';
import { RouteLeavingGuard } from '../../../../../components/RouteLeavingGuard';
import { Panel } from '../../../../../components/Panel';
import { t } from '../../../../../lib/i18n';
import { getLabelForEventType } from '../../../../../lib/getLabelForEventType';
import { MissingMarkingWarningPanel } from '../controls/MissingMarkingWarningPanel';

export default function LeftChairEventForm(props: EventFormProps) {
  const form = useEventSettingsForm({
    sensorType: 'roommate',
    eventType: 'ooc',
    initialValues: props.initialValues,
  });

  return (
    <form onSubmit={form.handleSubmit}>
      <RouteLeavingGuard when={form.dirty} />
      <h2>{getLabelForEventType('ooc', 'roommate')}</h2>

      <MissingMarkingWarningPanel
        onlyWarnWhenMissing={true}
        markingType="chair"
      />

      <Panel>
        <span
          dangerouslySetInnerHTML={{
            __html: t('manage.sensors.events.LeftChairEventForm.firstInfo'),
          }}
        />
      </Panel>

      <EventActiveControl form={form} />

      <EventTimeIntervalControl form={form} />

      <EventLevelControl form={form} />

      <PlayEventSoundControl form={form} />

      <EventFormControls form={form} />
    </form>
  );
}
